<template>
  <onboarding-account-owner />
</template>

<script>
import OnboardingAccountOwner from '../../../components/Onboarding/AccountOwner/index'
export default {
    components: {
        OnboardingAccountOwner
    }
}
</script>

<style>

</style>